import React, {Component} from 'react';
import {MONTHS} from "../../utils/constants";
import $ from 'jquery';

export default class SimpleMonthPicker extends Component{

  constructor(props){
    super(props);
    let now = new Date();

    this.state={date:now, month:now.getMonth(), year:now.getFullYear()}

    this.selectChange=this.selectChange.bind(this);
  }

  selectChange(){
    let month = $('#monthSelect').val() === -1 ? 0 : $('#monthSelect').val() ;
    let year = $('#yearSelect').val();
    let selectedDate = new Date();
    selectedDate.setFullYear(year);
    selectedDate.setMonth(month);
    this.setState({date:selectedDate, month:month, year:year});
    this.props.callbackFromParent(selectedDate);
  }
  render(){

    let months = MONTHS.map(month=>{

      if(this.state.year !== (new Date()).getFullYear()){
        return MONTHS.indexOf(month)===this.state.month ? <option selected={'selected'} value={MONTHS.indexOf(month)} key={MONTHS.indexOf(month)}>{month}</option> : <option value={MONTHS.indexOf(month)} key={MONTHS.indexOf(month)}>{month}</option>
      } else {
        let currentMonth = (new Date()).getMonth();
        if(MONTHS.indexOf(month)<=currentMonth){
          return MONTHS.indexOf(month)===this.state.month ? <option selected={'selected'} value={MONTHS.indexOf(month)} key={MONTHS.indexOf(month)}>{month}</option> : <option value={MONTHS.indexOf(month)} key={MONTHS.indexOf(month)}>{month}</option>
        }
      }
    });

    var years = [(new Date()).getFullYear()];
    for(var i=(new Date()).getFullYear() - 1; i >= 2016 ; i--){
      years.push(i);
    }

    let yearOpts = years.map(year=>{
      return year===(new Date()).getFullYear() ? <option selected={'selected'} value={year} key={year}>{year}</option> : <option value={year} key={year}>{year}</option>
    });

    return(
      <div style={{zIndex: '200', position: 'relative'}}>
        <select id={'yearSelect'} onChange={this.selectChange}>
          <option value={-1} key={-1}>Año</option>
          {yearOpts}
        </select>
        <select id={'monthSelect'} onChange={this.selectChange} className={'mr-1'}>
          <option value={-1} key={-1}>Mes</option>
          {months}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui-components/SimpleMonthPicker.js